<template>
  <div class="set_smail_line" v-loading="disabled">
    <el-form :model="passForm" :rules="passRules" ref="passForm" :hide-required-asterisk='true' class="set_form">
      <div class="address_box country">
        <el-form-item :label="$t('colon.country')" class="info_box" prop="Country">
          <!-- <el-select v-model="passForm.Country" class="info_ipt" placeholder="Please select state">
            <el-option :label="passForm.Country" :value="passForm.Country"></el-option>
          </el-select> -->
          <el-input class="info_ipt" v-model="passForm.Country" :disabled="true"></el-input>
        </el-form-item>
      <!-- <div class="currently">Currently, we only accept U.S. address.</div> -->
      </div>
      <div class="address_box">
        <el-form-item :label="$t('colon.name')" class="info_box" prop="UserName">
          <el-input class="info_ipt" v-model="passForm.UserName"></el-input>
        </el-form-item>
      </div>
      <div class="address_box">
        <el-form-item  :label="$t('colon.street1')"  class="info_box" prop="StreetAddress">
          <el-input class="info_ipt" v-model="passForm.StreetAddress"></el-input>
        </el-form-item>
        <el-form-item  :label="$t('colon.street2')" class="info_box" prop="StreetAddress2">
          <el-input class="info_ipt" v-model="passForm.StreetAddress2"></el-input>
        </el-form-item>
      </div>
      <div class="address_box">
        <el-form-item :label="$t('colon.city')" class="info_box" prop="City">
          <el-input class="info_ipt" v-model="passForm.City"></el-input>
        </el-form-item>
        <el-form-item :label="$t('colon.state')" class="info_box" prop="StateCode">
          <el-select v-model="passForm.StateCode" filterable class="info_ipt" @change='getState' :placeholder="$t('rules.selectState')">
            <el-option :label="item.EName" :value="item.Code" v-for="(item,index) in getAreas" :key="index"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="address_box">
        <el-form-item :label="$t('colon.zipCode')" class="info_box" prop="ZipCode">
          <el-input class="info_ipt" v-model="passForm.ZipCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('colon.phone')" class="info_box" prop="Phone">
          <el-input class="info_ipt" v-model="passForm.Phone"></el-input>
        </el-form-item>
      </div>
      <div class="set_btn">
        <el-button :disabled="disabled" @click="resetForm('passForm')">{{$t('base.cancel')}}</el-button>
        <el-button :disabled="disabled" type="primary" @click="submitForm('passForm')">{{$t('base.save')}}</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { getUser } from "@/api/public";
export default {
  name: 'addressbox',
  data() {
    var isChinese=(rule, value, callback) => {
      let msg=this.$t('rules.enterAddress')
      if(value == ''&&rule.field=='StreetAddress'){
          callback(new Error(msg));
      }
      let Country=''
      if(this.userInfo){
        Country=this.userInfo.MemberSource
      }
      let isChinese='HK,TWN,MO,CN'
      if(isChinese.indexOf(Country)>-1){
        let text=this.passForm.StreetAddress+this.passForm.StreetAddress2
        let reg = /[\u4E00-\u9FA5]/g;
        let ChineseLength=(text.match(reg) || []).length
        if(ChineseLength<4){
           msg=this.$t('rules.isChinese')
          callback(new Error(msg));
        }
        setTimeout(()=>{
        if (rule.field == 'StreetAddress') {
            if(ChineseLength < 4){
              this.$refs['passForm'].validateField('StreetAddress2')
            }
          }
        if(rule.field=='StreetAddress2'){
          this.$refs['passForm'].validateField('StreetAddress')
        }
        })
      }
      callback();
    }
    return {
      disabled: false,
      isNew: true,
      getAreas: '',
      locationOption:[],
      passForm: {
        Country: "",
        UserName: '',
        StreetAddress: '',
        StreetAddress2: '',
        City: '',
        StateCode: '',
        State: '',
        ZipCode: '',
        Phone: '',
      },
      passRules: {
        Country: [
          { required: true, message: this.$t('rules.enterCountry'), trigger: 'blur' }
        ],
        UserName: [
          { required: true, message: this.$t('rules.enterName'), trigger: 'blur' }
        ],
        StreetAddress: [
          { validator: isChinese, trigger: 'blur' },
          // { required: true, message: this.$t('rules.enterAddress'), trigger: 'blur' },
        ],
        StreetAddress2: [
        { validator: isChinese, trigger: 'blur' },
        ],
        City: [
          { required: true, message: this.$t('rules.enterCity'), trigger: 'blur' }
        ],
        StateCode: [
          { required: true, message: this.$t('rules.selectState'), trigger: 'change' }
        ],
        ZipCode: [
          { required: true, message: this.$t('rules.enterZipCode'), trigger: 'blur' }
        ],
        Phone: [
          { required: true, message: this.$t('rules.enterPhone'), trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    list: Object,
    uid: Number,
    userInfo:Object
  },
  created() {
    this.getNationIcons()
  },
  methods: {

    //获取全部国家图标地址
    getNationIcons() {
      let that = this
      this.$get(this.$interface.GetAllNationIcons, '').then(res => {
        if (res.Result != 0) {
          that.locationOption = res.Data
          that.passForm.Country=that.userInfo.MemberSource
          // res.Data.map(item=>{
          //   if(item.EnName==that.userInfo.LocationName){
          //     that.passForm.Country=item.Code
          //   }
          // })

          that.getAddress();
          //that.location.MemberSource = res.Data[0].Code
        }
      })
    },
    // 获取省市区列表
    getAddress() {
      let that = this;
      let data={code:that.passForm.Country}
      this.$get(this.$interface.GetAreas, data).then(res => {
        if (res.Result != 0) {
          that.getAreas = res.Data;
        }
        if (that.list.Id != undefined) {
          var Country=that.passForm.Country
          that.passForm = that.list
          that.passForm.Country=Country
        }
      })
    },
    // 设置州名称
    getState(val) {
      let that = this
      that.getAreas.map(res => {
        if (res.Code == val) {
          that.passForm.State = res.EName
        }
      })
    },
    // 新增或修改 收货地址
    submitForm(formName) {
      let that = this;
      // this.$emit('getData',this.list,'address')
      //console.log(this.passForm, 1)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled = true;
          let url = this.$interface.SaveAddresses
          let data = {
            "memberId": this.uid,
            "country": that.passForm.Country,
            "userName": that.passForm.UserName,
            "streetAddress": that.passForm.StreetAddress,
            "streetAddress2": that.passForm.StreetAddress2,
            "city": that.passForm.City,
            "stateCode": that.passForm.StateCode,
            "state": that.passForm.State,
            "zipCode": that.passForm.ZipCode,
            "phone": that.passForm.Phone
          }
          if (that.list.Id != undefined) {
            url = this.$interface.UpdateAddresses;
            data.id = that.list.Id
            data.isDefault = that.list.IsDefault
          }
          this.$post(url, data).then(res => {
            if (res.Result != 0) {
              this.$refs[formName].resetFields();
              this.$emit('getData', true, 'address', that.list.Id)
            } else {
              this.$message({
                type: 'error',
                message: res.Msg
              });
              that.disabled = false;
            }
          })
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('getData', false, 'address')
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/settings.css";

</style>



// WEBPACK FOOTER //
// src/components/form/address.vue